import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53d0443c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "default_box" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "default_content" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Continue Shopping")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: 'https://image.kilimall.com/kenya/new_wap/cart/cart_default_bg@2x.png'.webpFilters()
,
      alt: ""
    }, null, 8, _hoisted_2),
    _createElementVNode("p", null, _toDisplayString($props.title), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString($props.content), 1),
    _createVNode(_component_van_button, {
      plain: "",
      round: "",
      type: "primary",
      class: "go_home_btn",
      color: "#F76900",
      onClick: $setup.goHomeFn
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}